import defaultState from './state'
import mutations from './mutations'
import actions from './actions'

const driverMonitor = {
  namespaced: true,
  state: {
    ...defaultState,
  },
  mutations,
  actions,
}

export default driverMonitor



// WEBPACK FOOTER //
// ./src/store/driverMonitor/index.js